import { Api } from "@/utils/http/types";
import { RequestEnum } from "@/enums/httpEnum";

const WebsiteApis = {
  /* 工具 */
  getWebsitesByCatalogId: new Api({
    url: "/api/website/tool/getWebsitesByCatalog",
    desc: "获取目录下的所有网址(包括一级子目录)",
    method: RequestEnum.GET
  }),
  getCommonlyWebsites: new Api({
    url: "/api/website/tool/getCommonlyWebsites",
    desc: "获取常用网址",
    method: RequestEnum.GET
  }),
  changeCommonlyWebsite: new Api({
    url: "/api/website/tool/changeCommonlyWebsite",
    desc: "添加或移除常用网址",
    method: RequestEnum.GET
  }),
  saveOrUpdateWebsite: new Api({
    url: "/api/website/tool/saveOrUpdate",
    desc: "保存或更新",
    method: RequestEnum.POST
  }),
  deleteWebsite: new Api({
    url: "/api/website/tool/delete",
    desc: "删除",
    method: RequestEnum.DELETE
  }),
  selectWebsiteById: new Api({
    url: "/api/website/tool/selectById",
    desc: "根据ID查询",
    method: RequestEnum.GET
  }),
  selectAllWebsite: new Api({
    url: "/api/website/tool/selectAll",
    desc: "查询所有",
    method: RequestEnum.GET
  }),
  selectPageWebsite: new Api({
    url: "/api/website/tool/selectByPage",
    desc: "分页查询",
    method: RequestEnum.GET
  }),
  /* 书签 */
  getWebsitesByCatalogId2: new Api({
    url: "/api/website/collection/getWebsitesByCatalog",
    desc: "获取目录下的所有网址",
    method: RequestEnum.GET
  }),
  saveOrUpdateWebsite2: new Api({
    url: "/api/website/collection/saveOrUpdate",
    desc: "保存或更新",
    method: RequestEnum.POST
  }),
  deleteWebsite2: new Api({
    url: "/api/website/collection/delete",
    desc: "删除",
    method: RequestEnum.DELETE
  }),
  selectWebsiteById2: new Api({
    url: "/api/website/collection/selectById",
    desc: "根据ID查询",
    method: RequestEnum.GET
  }),
  selectAllWebsite2: new Api({
    url: "/api/website/collection/selectAll",
    desc: "查询所有",
    method: RequestEnum.GET
  }),
  selectPageWebsite2: new Api({
    url: "/api/website/collection/selectByPage",
    desc: "分页查询",
    method: RequestEnum.GET
  })
};

export default WebsiteApis;

export interface Website {
  id?: number;
  title?: string;
  description?: string;
  url?: string;
  status?: number;
  type: number;
  catalogId?: number;
  createTime?: string;
  updateTime?: string;
  commonly?: number;
}

export interface ToolCatalog {
  id?: number;
  parentId?: number;
  name?: string;
  description?: string;
  sequence?: number;
  status?: number;
  type?: number;
  createTime?: string;
  updateTime?: string;
  websites?: Website[];
  subCatalog?: ToolCatalog[];
}
